// no need to verify file
import React, { useEffect, useRef } from "react";
import Head from "next/head";
import animateScrollTo from "animated-scroll-to";

import PageLayout from "../../components/_Layout/PageLayout";
import LandingContents from "../../components/Landing/LandingContents";
import { Button } from "react-bootstrap";
import { reachGoal } from "../../libs/helpers/metrics";

export default function About() {
  const $contentRef = useRef();
  const $blurRef = useRef();

  useEffect(() => {
    /**
     * Parallax scroll effect
     * Created by Sallar Kaboli <sallar.kaboli@gmail.com>
     */
    var $content = $contentRef.current,
      $blur = $blurRef.current,
      wHeight = window.innerHeight;

    function onResize() {
      wHeight = window.innerHeight;
    }

    window.addEventListener("resize", onResize.bind(this));

    /**
     * requestAnimationFrame Shim
     */
    window.requestAnimFrame = (function () {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    })();

    /**
     * Scroller
     */
    function Scroller() {
      this.latestKnownScrollY = 0;
      this.ticking = false;
    }

    Scroller.prototype = {
      /**
       * Initialize
       */
      init: function () {
        window.addEventListener("scroll", this.onScroll.bind(this), false);
      },

      /**
       * Capture Scroll
       */
      onScroll: function () {
        this.latestKnownScrollY = window.scrollY;
        this.requestTick();
      },

      /**
       * Request a Tick
       */
      requestTick: function () {
        if (!this.ticking) {
          window.requestAnimFrame(this.update.bind(this));
        }
        this.ticking = true;
      },

      /**
       * Update.
       */
      update: function () {
        var currentScrollY = this.latestKnownScrollY;
        this.ticking = false;

        /**
         * Do The Dirty Work Here
         */
        var slowScroll = currentScrollY / 4,
          blurScroll = currentScrollY * 2;

        $content.style.transform = "translateY(-" + slowScroll + "px)";

        $blur.style.opacity = blurScroll / wHeight;
      }
    };

    /**
     * Attach!
     */
    var scroller = new Scroller();
    scroller.init();
    return () => {
      // cleanup from events
      window.removeEventListener("scroll", scroller.onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const onShowMoreClick = () => {
    reachGoal("Click_Landing_Learn_more");
    const landingStart = document.getElementById("how-it-works");
    animateScrollTo(landingStart);
  };

  return (
    <PageLayout>
      <main>
        <Head>
          <title>Travel Buddy – Help during traveling</title>
        </Head>
        <div className="welcome">
          <div ref={$contentRef} className="welcome-content">
            <div className="welcome-content-group py-4">
              <h1>TRAVEL BUDDY</h1>
              <p>
                Have you ever gone to a new city and didn’t know where to find the simplest things?
                <br /> Like the best hairdresser in town or the best frozen latte on the go?
              </p>
              <p>
                With Travel Buddy you have the wildest desires and find the solution for them
                <br /> with a local person that has the know-how and where.
              </p>
              <Button onClick={onShowMoreClick} use="primary" className="mt-4">
                Learn more
              </Button>
            </div>
          </div>
          <div ref={$blurRef} className="welcome-overlay"></div>
        </div>
        <LandingContents />
      </main>
    </PageLayout>
  );
}
